import script from "./CopyTrigger.vue?vue&type=script&lang=js"
export * from "./CopyTrigger.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__